module.exports = __webpack_public_path__ + "img/ci.11438db3.jpg";